// extracted by mini-css-extract-plugin
export default {"wrapper":"projectColumn_wrapper__1y6xY","employeeWrapper":"projectColumn_employeeWrapper__p5mCK","isForgotten":"projectColumn_isForgotten__WZWH+"};